import { render, staticRenderFns } from "./ProspectPropositionUpdate.vue?vue&type=template&id=4cb39cca"
import script from "./ProspectPropositionUpdate.vue?vue&type=script&lang=ts"
export * from "./ProspectPropositionUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports